import {useState} from "react";
import Button from "react-bootstrap/Button";
import {MessageDialog} from "./messageDialog";

export function Unauthenticated(props){
    const [userName, setUserName] = useState(props.userName);
    const [password, setPassword] = useState("");
    const [showMessageDialog, setShowMessageDialog] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('login'); // 'login' or 'signup'
    
    async function loginUser() {
        setIsLoading(true);
        await loginOrCreate(`/api/auth/login`);
        setIsLoading(false);
    }
    
    async function createUser() {
        setIsLoading(true);
        await loginOrCreate(`/api/auth/create`);
        setIsLoading(false);
    }
    
    function logout() {
        fetch(`/api/auth/logout`, {
            method: 'delete',
        }).then(() => {
            localStorage.removeItem('userName');
            props.onlogout();
        });
    }
    
    async function loginOrCreate(endpoint) {
        const userName = document.querySelector('#userName')?.value;
        const password = document.querySelector('#userPassword')?.value;
        
        if (!userName || !password) {
            setShowMessageDialog("⚠ Please fill in all fields");
            return;
        }
        
        const response = await fetch(endpoint, {
            method: 'post',
            body: JSON.stringify({ email: userName, password: password }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
        });

        if (response?.status === 200) {
            localStorage.setItem('userName', userName);
            props.onlogin(userName);
        } else {
            const body = await response.json();
            setShowMessageDialog(`⚠ Error: ${body.msg}`);
        }
    }
    
    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="auth-header">
                    <div className="auth-tabs">
                        <button
                            className={`auth-tab ${activeTab === 'login' ? 'active' : ''}`}
                            onClick={() => setActiveTab('login')}
                        >
                            [ SIGN IN ]
                        </button>
                        <button
                            className={`auth-tab ${activeTab === 'signup' ? 'active' : ''}`}
                            onClick={() => setActiveTab('signup')}
                        >
                            [ CREATE ]
                        </button>
                    </div>
                </div>

                <div className="auth-body">
                    <div className="auth-form">
                        <div className="form-group">
                            <label htmlFor="userName" className="form-label">
                                <span className="form-icon">&gt;</span>
                                user
                            </label>
                            <input
                                className="form-input"
                                type="text"
                                id="userName"
                                placeholder="username"
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="userPassword" className="form-label">
                                <span className="form-icon">&gt;</span>
                                pass
                            </label>
                            <input
                                className="form-input"
                                type="password"
                                id="userPassword"
                                placeholder="••••••••"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>

                        <div className="form-actions">
                            {activeTab === 'login' ? (
                                <Button
                                    className="auth-button primary"
                                    onClick={loginUser}
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <><span className="spinner"></span> authenticating</>
                                    ) : '[ AUTHENTICATE ]'}
                                </Button>
                            ) : (
                                <Button
                                    className="auth-button secondary"
                                    onClick={createUser}
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <><span className="spinner"></span> creating</>
                                    ) : '[ CREATE ACCOUNT ]'}
                                </Button>
                            )}
                        </div>

                        <div className="auth-footer">
                            <p className="auth-info">
                                {activeTab === 'login'
                                    ? '> no account? '
                                    : '> have an account? '
                                }
                                <button
                                    className="auth-link"
                                    onClick={() => setActiveTab(activeTab === 'login' ? 'signup' : 'login')}
                                >
                                    {activeTab === 'login' ? 'create one' : 'sign in'}
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <MessageDialog message={showMessageDialog} onHide={() => setShowMessageDialog(null)}/>
        </div>
    )
}